import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

export const schemaChatLinkedPayload = z.object({
    loanRequestId: schemaId,
});

export type Schema_ChatLinkedPayload = z.infer<typeof schemaChatLinkedPayload>;
